import { SET_POI, SET_POIS, FETCH_POIS } from "./constants";
import { api } from "../../config";
import { setFiltered } from "../filtered";
import axios from "axios";

export const getPois = ({ state }) => () =>
	new Promise(resolve => {
		resolve(state);
	});
export const fetchPois = () => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		const { pois } = getState();
	});
export const setPois = routeName => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_POIS,
			routeName,
			building
		});
		resolve(routeName);
	});
export const getPoi = poi => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_POI,
			poi,
			building
		});
		resolve(poi);
	});
